<template>
  <Dialog
    v-model:visible="visibleLocal"
    @hide="$emit('close')"
    modal
    header="Подтверждение"
    :style="{ width: '30rem' }"
  >
    <span
      >Вы уверены, что хотите редактировать этот {{ objectName }}? С ним могут
      быть созданы сегменты или запущены рекламные кампании. Информация
      изменится во всех существующих объектах системы.</span
    >
    <div class="flex buttons">
      <Button
        type="button"
        label="Редактировать"
        @click="$emit('edit')"
      ></Button>
      <Button
        type="button"
        label="Отменить"
        severity="secondary"
        @click="$emit('close')"
      ></Button>
    </div>
  </Dialog>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import Dialog from "primevue/dialog";
import Button from "primevue/button";

import { useRouter } from "vue-router";
const router = useRouter();

const props = defineProps<{
  visible: boolean;
  objectName: string;
}>();

const emits = defineEmits(["close", "edit"]);

const visibleLocal = ref(props.visible);
watch(
  () => props.visible,
  (newValue) => {
    visibleLocal.value = newValue;
  }
);
</script>

<style lang="scss" scoped>
.buttons {
  margin-top: 20px;
  button {
    flex: 1;

    &:first-child {
      margin-right: 20px;
    }
  }
}
</style>
